import React, {useState} from 'react'
import ScheduledCalls from './schedule_calls'
import FeedBack from './feedback_form'
import AddOnTable from './addOn_table'
import ContactUs from './contact_us'
import RadioButtons from '../GenericTable/radio_buttons'

const CustomerInteraction = () => {
  const tabs = ['Add On Enquiries', 'Scheduled Calls', 'Feedback','Contact Us']
  const [activeTab, setActiveTab] = useState(tabs[0])

  const renderComponent = () => {
    switch (activeTab) {
      case 'Add On Enquiries':
        return <AddOnTable />
      case 'Scheduled Calls':
        return <ScheduledCalls />
      case 'Contact Us':
        return <ContactUs/>
      case 'Feedback':
        return <FeedBack/>
      default:
        return null
    }
  }

  return (
    <>
        <div className='card mb-6 mb-xl-9 mt-2' >
        <div style={{ display: 'flex', justifyContent: 'space-between'}}>
          <RadioButtons tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
        <div>{renderComponent()}</div>
      </div>
      {/* <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '15px',
        }}
       >
        <RadioButtons tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      <div>{renderComponent()}</div> */}
     
    </>
  )
}

export default CustomerInteraction
